import { stripCloneSuffix } from '@/features/datasets/utils/datasetCloneNames';

/**
 * User-chosen dataset name validation for the Generate-with-AI / Retrieval
 * Agent wizards. Mirrors the backend rules
 * (optuneutils/dataset/custom_dataset_names.py): names become Mongo collection
 * names, so no "." / "$", capped at the generated-name length budget, and
 * unique across the client's datasets (clone-suffix-stripped comparison).
 */
export const MAX_DATASET_NAME_LENGTH = 40;

export const DATASET_NAME_REQUIRED_ERROR = 'Dataset name is required.';
export const DATASET_NAME_EXISTS_ERROR =
    'A dataset with this name already exists. Choose a different name.';

export function datasetNameValidationError(name, existingNames = [], { requireValue = false } = {}) {
    const trimmed = (name || '').trim();
    if (!trimmed) return requireValue ? DATASET_NAME_REQUIRED_ERROR : '';
    if (/[.$]/.test(trimmed)) return 'Dataset name cannot contain "." or "$".';
    if (trimmed.length > MAX_DATASET_NAME_LENGTH) {
        return `Dataset name must be at most ${MAX_DATASET_NAME_LENGTH} characters.`;
    }
    const taken = new Set(
        (existingNames || []).map((existing) => stripCloneSuffix(existing) || existing).filter(Boolean)
    );
    if (taken.has(trimmed)) return DATASET_NAME_EXISTS_ERROR;
    return '';
}
